import { observer } from "mobx-react";
import { Button } from "../../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import IconResendStatusEmail from "../../../../../../components/icons/icon-resend-status-email/icon-resend-status-email";
import { useState } from "react";
import RmaPageStore from "../../../stores/rma-page-store";
import { IRMAEmailLog } from "../../../rma-types";
import IconCircle from "../../../../../../components/icons/icon-circle/icon-circle";
import IconNext from "../../../../../../components/icons/icon-next/icon-next";
import IconChevronDown from "../../../../../../components/icons/icon-chevron-down/icon-chevron-down";

import './resend-status-email-button.scss';
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    rma: RmaPageStore;
    setCurrentEmailLog: (emailLog: IRMAEmailLog) => void;
}

const ResendStatusEmailButton: React.FC<IProps> = observer(({ rma, setCurrentEmailLog }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-rma-card';

    const [ isExpanded, setIsExpanded ] = useState<boolean>(false);

    const onResendButtonClicked = (emailLog: IRMAEmailLog) => {
        setCurrentEmailLog(emailLog);
        setIsExpanded(false);
    }

    const ExpandIcon = isExpanded ? IconChevronDown : IconNext;

    return (
        <>
            <Button 
                variant={BUTTON_VARIANTS.Default} 
                leftIcon={IconResendStatusEmail}
                text={getTranslation('RESEND_STATUS_EMAIL_OPTION', scope)}
                onClick={() => setIsExpanded(!isExpanded)}
                rightIcon={ExpandIcon}
            />
            {isExpanded &&
                <div className="resend-email-list">
                    { 
                        rma.emailLogList.map(emailLog => (
                            <Button 
                                key={emailLog.id}
                                variant={BUTTON_VARIANTS.Default} 
                                leftIcon={IconCircle}
                                text={emailLog.translation_key ? getTranslation(emailLog.translation_key, scope) : emailLog.label} 
                                onClick={() => onResendButtonClicked(emailLog)}
                            />
                        ))
                    }
                </div>
            }
        </>
    );
});

export default ResendStatusEmailButton;